import * as React from "react"
import { usePage } from "@inertiajs/react"
import { ClipboardList, GraduationCap, Home, Layers, ListChecks, MessageSquareWarning, Palette, Settings, ThumbsUp, Users } from "lucide-react"
import { MainNav, type NavItemDef } from "@/components/MainNav"
import type { PageProps } from "@/types/inertia"

const ADMIN_NAV_ITEMS: NavItemDef[] = [
  {
    href: "/",
    icon: Home,
    label: "App Home",
    match: () => false,
  },
  {
    href: "/admin/users",
    icon: Users,
    label: "Users",
    adminOnly: true,
    match: (url) => url.startsWith("/admin/users"),
  },
  {
    href: "/admin/programs",
    icon: GraduationCap,
    label: "Programs",
    adminOnly: true,
    match: (url) => url.startsWith("/admin/programs"),
  },
  {
    href: "/admin/decks",
    icon: Layers,
    label: "Official decks",
    match: (url) => url.startsWith("/admin/decks"),
  },
  {
    href: "/admin/quizzes",
    icon: ListChecks,
    label: "Official quizzes",
    match: (url) => url.startsWith("/admin/quizzes"),
  },
  {
    href: "/admin/practice_exams",
    icon: ClipboardList,
    label: "Practice exams",
    match: (url) => url.startsWith("/admin/practice_exams") || url.startsWith("/admin/case_studies"),
  },
  {
    href: "/admin/feedbacks",
    icon: MessageSquareWarning,
    label: "Feedback",
    adminOnly: true,
    match: (url) => url.startsWith("/admin/feedbacks"),
    badgeProp: "feedback_unreviewed_count",
  },
  {
    href: "/admin/question_ratings",
    icon: ThumbsUp,
    label: "Explanation ratings",
    adminOnly: true,
    match: (url) => url.startsWith("/admin/question_ratings"),
  },
  {
    href: "/admin/settings",
    icon: Settings,
    label: "Settings",
    adminOnly: true,
    match: (url) => url.startsWith("/admin/settings"),
  },
  {
    href: "/admin/design-system",
    icon: Palette,
    label: "Design System",
    adminOnly: true,
    match: (url) => url.startsWith("/admin/design-system"),
  },
]

export function AdminShell({ children }: { children: React.ReactNode }) {
  const admin = usePage<PageProps>().props.current_user?.admin ?? false
  return (
    <div className="flex min-h-screen bg-canvas text-ink-body">
      <MainNav items={ADMIN_NAV_ITEMS} brandHref={admin ? "/admin/users" : "/admin/decks"} showAdminLink={false} />
      <main className="flex min-w-0 flex-1 flex-col lg:p-2 lg:pl-0">
        <div className="flex-1 bg-page px-6 py-8 sm:px-10 lg:rounded-xl lg:shadow-xs lg:ring-1 lg:ring-ink-display/5 dark:lg:ring-white/10">
          <div className="mx-auto max-w-4xl">{children}</div>
        </div>
      </main>
    </div>
  )
}
